// client/src/services/paymentItemService.js
import api from './api';

const paymentItemService = {
  getPaymentItems: async () => {
    const response = await api.get('/payment-items');
    return response.data;
  },
  
  getPaymentItem: async (id) => {
    const response = await api.get(`/payment-items/${id}`);
    return response.data;
  },
  
  createPaymentItem: async (itemData) => {
    const response = await api.post('/payment-items', itemData);
    return response.data;
  },
  
  updatePaymentItem: async (id, itemData) => {
    const response = await api.put(`/payment-items/${id}`, itemData);
    return response.data;
  },
  
  deletePaymentItem: async (id) => {
    const response = await api.delete(`/payment-items/${id}`);
    return response.data;
  },

  getAvailableItemsForBylaw: async (bylawId, transactionId = null) => {
    const response = await api.get(`/payment-items/available-for-bylaw/${bylawId}`, {
      params: transactionId ? { transactionId } : {},
    });
    return response.data;
  }

  
};

export default paymentItemService;